import fetch from './fetch';
import {API_VERSION_STRING} from '../../const';

export default {
  getBotProSearch: function({baseUrl, accessToken, locale, payload}) {
    const url = `/${API_VERSION_STRING}arbs/bot_pro_search?access_token=${accessToken}&locale=${locale}`;
    return fetch(baseUrl, url, 'post', payload);
  },
  getValueBetsBotProSearch: function({baseUrl, accessToken, locale, payload}) {
    const url = `/${API_VERSION_STRING}valuebets/bot_pro_search?access_token=${accessToken}&locale=${locale}`;
    return fetch(baseUrl, url, 'post', payload);
  },
  getValueBetsBotProSearchV2: function({baseUrl, accessToken, locale, payload}) {
    const url = `/api/v2/valuebets/bot_pro_search?access_token=${accessToken}&locale=${locale}`;
    return fetch(baseUrl, url, 'post', payload);
  },
};
